import { gql } from '@/shared/graphql/generated/cache';

export const getLatestAuctionQuery = gql(/* GraphQL */ `
  query GetLatestAuction {
    auction: auctionById(id: 1) {
      minActiveBid
      startBlockNumber
      endBlockNumber
      currentHeight
      redemptionPeriodAsPercentage
      targetSetSize
      authorityRotationEnabled
      minBid
      blockReward
    }
    delegations: allDelegations {
      aggregates {
        sum {
          upcomingAmount
        }
      }
    }
  }
`);
